module.exports = __webpack_public_path__ + "static/media/Bg_header_1.566fcc38.jpg";